:host {
  background: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: var(--spacer);
  overflow-y: scroll;

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: calc(2 * var(--spacer)) calc(3 * var(--spacer));
  }

  #product-trials-app-error-title {
    margin-bottom: var(--spacer);
  }

  #product-trials-app-error-text {
    font-size: var(--body-size-medium);
    font-weight: 400;
  }

  .product-trials-app-error-container {
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  &.is-error {
    #product-trials-app-home-page {
      display: none;
    }

    #product-trials-app-landing-page {
      display: none;
    }

    .product-trials-app-error-container {
      display: flex;
    }
  }

  &.is-empty {
    #product-trials-app-home-page {
      display: none;
    }

    #product-trials-app-landing-page {
      display: none;
    }

    .product-trials-app-error-container {
      display: flex;
    }
  }

  &:not(.is-error):not(.is-empty):not(.is-loading) {
    #product-trials-app-home-page {
      display: flex;
    }

    #product-trials-app-landing-page {
      display: flex;
    }

    .product-trials-app-error-container {
      display: none;
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .loading-container {
      display: flex;
    }

    #product-trials-app-home-page {
      display: none;
    }

    #product-trials-app-landing-page {
      display: none;
    }

    .product-trials-app-error-container {
      display: none;
    }
  }
}
